export enum CalendarEventTitle {
	CASE_TYPE_NAME = 'caseTypeName',
	PATIENT_NAME = 'patientName',
}
